import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { Notification } from '@/lib/schemas';
import { useAuth } from './useAuth';

export function useNotifications() {
  const { user } = useAuth();

  return useQuery<Notification[], Error>({
    queryKey: ['notifications', user?.user_id],
    queryFn: () => api.getNotifications(),
    staleTime: 0,
    gcTime: 0,
    enabled: !!user,
  });
}

export function useUnreadNotifications() {
  const { user } = useAuth();

  return useQuery<Notification[], Error>({
    queryKey: ['notifications', user?.user_id, 'unread'],
    queryFn: () => api.getUnreadNotifications(),
    staleTime: 0,
    gcTime: 0,
    enabled: !!user,
  });
}

export function useMarkNotificationRead() {
  const queryClient = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: (notificationId) => api.markNotificationRead(notificationId),
    onSuccess: () => {
      // Invalidate all notification queries for current user
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
}
